import type { SVGProps } from "react";
export interface SchoolIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SchoolIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SchoolIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.625 8.876H19A3.125 3.125 0 0 1 22.125 12v9a1.125 1.125 0 0 1-2.25 0v-9a.875.875 0 0 0-.875-.874h-1.5A1.125 1.125 0 0 1 16.375 10V5.388L12.42 3.23a.88.88 0 0 0-.738-.047l-.1.047-3.956 2.158V10c0 .62-.504 1.125-1.125 1.125H5a.875.875 0 0 0-.875.874v9a1.125 1.125 0 0 1-2.25 0v-9A3.125 3.125 0 0 1 5 8.876h.375V5.313c0-.777.425-1.492 1.107-1.865l4.02-2.194.178-.09a3.13 3.13 0 0 1 2.817.09l4.021 2.194.243.156c.539.397.864 1.029.864 1.71z"
      />
      <path
        fill={color}
        d="M12.875 17a.876.876 0 1 0-1.75 0v2.875h1.75zm6-3a1.375 1.375 0 0 1-2.742.141l-.008-.14.008-.141a1.375 1.375 0 0 1 1.367-1.235l.14.007c.694.07 1.235.656 1.235 1.369Zm-6-5a.875.875 0 1 0-1.75 0 .875.875 0 0 0 1.75 0m-5 8a1.375 1.375 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 6.5 15.625l.14.007c.694.07 1.235.657 1.235 1.368m7.25 2.875H22a1.125 1.125 0 0 1 0 2.25H2a1.125 1.125 0 0 1 0-2.25h6.875V17a3.126 3.126 0 1 1 6.25 0zM18.875 17a1.375 1.375 0 0 1-2.742.141l-.008-.14.008-.141a1.375 1.375 0 0 1 1.367-1.235l.14.007c.694.07 1.235.656 1.235 1.368m-11-3a1.375 1.375 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 6.5 12.625l.14.007c.694.07 1.235.657 1.235 1.369Zm7.25-5a3.126 3.126 0 1 1-6.252 0 3.126 3.126 0 0 1 6.252 0"
      />
    </svg>
  );
}
